import * as React from 'react';
const SvgProjectManagement = (props) => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M33.91 118c0-1.871-1.87-3.742-5.612-5.613l-7.484-3.742s-3.742 1.871-9.355 1.871-9.355-1.871-9.355-1.871M16.206 103.032c4.411-2.942 4.004-4.827 4.528-9.107.28-2.31.37-4.794-.743-6.913-1.02-1.941-2.896-3.283-4.94-3.976a11.317 11.317 0 0 0-7.184 0c-2.049.693-3.92 2.035-4.94 3.976-1.113 2.119-1.029 4.607-.743 6.913.524 4.276.117 6.165 4.527 9.107M41.292 112.387l7.484-7.484H33.808M48.776 104.903v-18.71a3.74 3.74 0 0 0-3.743-3.741H28.195M113.291 103.032c4.41-2.942 4.003-4.827 4.527-9.107.281-2.31.37-4.794-.743-6.913-1.02-1.941-2.896-3.283-4.94-3.976a11.315 11.315 0 0 0-7.184 0c-2.049.693-3.92 2.035-4.94 3.976-1.113 2.119-1.029 4.607-.743 6.913.523 4.276.117 6.165 4.527 9.107M117.898 108.645s-3.742 1.871-9.355 1.871c-5.612 0-9.354-1.871-9.354-1.871l-7.484 3.742c-3.742 1.871-5.613 3.742-5.613 5.613M78.71 112.387l-7.483-7.484h14.967M71.227 104.903v-18.71a3.74 3.74 0 0 1 3.742-3.741h16.838M110.518 39.42H76.84L61.873 50.644V5.742A3.74 3.74 0 0 1 65.615 2h44.903a3.741 3.741 0 0 1 3.742 3.742v29.935a3.741 3.741 0 0 1-3.742 3.742Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.969 24.452a3.742 3.742 0 1 0 0-7.484 3.742 3.742 0 0 0 0 7.484ZM88.066 24.452a3.742 3.742 0 1 0 0-7.484 3.742 3.742 0 0 0 0 7.484ZM101.163 24.452a3.742 3.742 0 1 0 0-7.485 3.742 3.742 0 0 0 0 7.485Z"
      fill="#000"
    />
    <path
      d="M110.517 50.645v22.452M9.485 73.097V26.323a7.482 7.482 0 0 1 7.484-7.484h33.678"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.04 56.258c4.41-2.942 4.003-4.827 4.527-9.107.28-2.31.37-4.794-.744-6.913-1.02-1.941-2.895-3.284-4.94-3.976a11.313 11.313 0 0 0-7.184 0c-2.048.692-3.92 2.035-4.94 3.976-1.112 2.119-1.028 4.607-.743 6.913.524 4.275.117 6.165 4.528 9.107M63.744 73.097c0-3.742-1.871-5.613-5.613-7.484l-7.484-3.742s-3.742 1.87-9.355 1.87-9.355-1.87-9.355-1.87l-7.484 3.742c-3.742 1.87-5.613 3.742-5.613 7.484"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgProjectManagement;
